
import React, {  useState } from 'react';
import Select from "../common/Select";


const stripLeadingHeadingNumber = (title) => {
    if (!title || typeof title !== 'string') return title;
    return title.replace(/^\s*(?:\d+(?:\.\d+)*\s*[\.\-\:]\s*|\d+\s+(?=[A-Za-z])|\(\d+\)\s*)/i, '').trim();
};

const TableOfContent = ({ pagename,details}) => {
    
    const [seleted, setseleted] = useState('');
    function handleauthorInput(e)
    {
        setseleted(e);
        const cleanE = stripLeadingHeadingNumber(e);
        const element = document.getElementById(`viewScroll${e}`) || document.getElementById(`viewScroll${cleanE}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
    const cleanDetails = details.map((val) => stripLeadingHeadingNumber(val));
    return (
        <div className="fieldWrap mt-4 mb-4">
        <label className="labelForm">
            Table of Contents
        </label>
        <div className="selectBox">
        <Select
            selectedValue={seleted}
            options={cleanDetails}
            optionValues={cleanDetails}
            name={`tbl`}
            placeholder=""
            handleChange={(e) =>
                handleauthorInput(e)
            }
            
            mandatory={false}
            
            
            /> 
        </div>
    </div>
   
    );
};
export default TableOfContent;